import moment, { Moment } from 'moment';

import { BaseInvite } from '@commonTuna/react/objects/BaseInvite';
import { TemplateType } from '@commonTuna/react/objects/BaseTemplate';

import { request } from '@app/components/Api';

interface Named {
	firstName: string;
	lastName: string;
}

interface NamedWithEmail extends Named {
	email: string;
}

export const getAppContainer = (): HTMLElement => document.body.querySelector('.app-container') || document.body;

export const getParentWidth = (parentSelector: string): number | undefined => {
	if (typeof document !== 'undefined' && typeof window !== 'undefined') {
		const parentEl = document.querySelector(parentSelector);
		if (!parentEl) {
			return;
		}

		const parentStyle = window.getComputedStyle(parentEl, null);
		if (!parentStyle.width) {
			return;
		}

		return parseInt(parentStyle.width, 10)
			- parseInt(parentStyle.paddingLeft || '', 10)
			- parseInt(parentStyle.paddingRight || '', 10);
	}
};

export const getUserNameOrUnnamedWithEmail = (item?: NamedWithEmail) => {
	if (item) {
		const name = (!item.lastName && !item.firstName) ? 'Unnamed' : `${item.lastName || ''} ${item.firstName || ''}`;
		return `${name}  ${item.email ? `(${item.email})` : ''}`;
	}
	return '';
};

export const timeSpanToMinutes = (timeSpan: string): number | null => {
	const timeArr = timeSpan.split(':');
	if (timeArr.length === 3) {
		const hours = +timeArr[0];
		const minutes = +timeArr[1];
		return hours ? hours * 60 + minutes : minutes;
	}
	return null;
};

export const dateTimeFormatString = 'MM/DD/YYYY h:mm A';

export const dateToUtc = (date): Moment => {
	const offset = moment().utcOffset();
	return moment(date).subtract(offset, 'minutes');
};

export const dateToUtcString = (date, format): string => {
	const utc = dateToUtc(date);
	return moment(utc).format(format);
};
